<template>
  <div>
    <b-container class="container-box">
      <b-row class="no-gutters">
        <b-col xl="5" class="text-center text-sm-left mb-3 mb-sm-0">
          <h1 class="mr-sm-4 header-main text-uppercase">รายการธุรกรรม</h1>
        </b-col>
        <b-col xl="7" class="text-right d-flex justify-content-end">
          <FinanceFilter
            v-on:onSubmitFilter="submitFilter"
            v-on:setFilter="setFilter"
            v-on:onSearchStatementNo="searchStatementNo"
            :paymentStatus="paymentStatus"
            :filter="filter"
          />
        </b-col>
      </b-row>
      <b-tabs content-class="mt-0" class="mt-3 finance-tabs">
        <b-tab
          v-for="(item, index) in paymentStatus"
          :key="index"
          :title="item.name + ' (' + item.count + ')'"
          :active="isActive(item.id)"
          @click="selectTab(item.id)"
        >
        <FinanceList
          ref="FinanceComponent"
          :getFinanceList="getFinanceList"
          :onsetFilter="setFilter"
          :items="items"
          :rows="rows"
          :filter="filter"
          :isBusy="isBusy"
        />
          
        </b-tab>
      </b-tabs>
    </b-container>
  </div>
</template>

<script>
import FinanceFilter from "./components/finance-filter/FinanceFilter.vue";
import FinanceList from "./components/finance-list/FinanceList.vue";

export default {
  components: {
    FinanceFilter,
    FinanceList 
  },
  data() {
    return {
      activeItem: "",
      paymentStatus: [],
      filter: {
        page : 1,
        take : 10,
        market: "",
        keyword : "",
        startDate : "",
        endDate : "",
        saleChannelId : "",
        paymentStatusIds : []
      },
      items: [],
      rows: null,
      isBusy: false,
      marketList: [],
      tabCurrent: 0,
    };
  },
  created: async function() {
    this.getFinanceList()
    await this.getFilter();
  },
  methods: {
    getFilter(){
      if(this.$route.query.page){
        this.filter.page = parseInt(this.$route.query.page) || 1;;
      }
      if(this.$route.query.take){
        this.filter.take = parseInt(this.$route.query.page) || 10;
      }
      if(this.$route.query.market){
        this.filter.market = this.$route.query.market;
      }
      if(this.$route.query.keyword){
        this.filter.keyword = this.$route.query.keyword;
      }
      if(this.$route.query.startDate){
        this.filter.startDate = this.$route.query.startDate;
      }
      if(this.$route.query.endDate){
        this.filter.endDate = this.$route.query.endDate;
      }
      if(this.$route.query.saleChannelId){
        this.filter.saleChannelId = this.$route.query.saleChannelId;
      }
      if(this.$route.query.paymentStatusIds){
        this.filter.paymentStatusIds = this.$route.query.paymentStatusIds;
      }
      this.tabCurrent = this.$route.query.tab || 0;
      this.activeItem = this.tabCurrent;
    },
    setFilter(){
      this.$router.push({ path: '/finance', 
        query: { 
          brandID: this.$route.query.brandID,
          market : this.filter.market,
          keyword : this.filter.keyword,
          startDate : this.filter.startDate || "",
          endDate : this.filter.endDate || "",
          saleChannelId : this.filter.saleChannelId.toString(),
          paymentStatusIds : this.filter.paymentStatusIds,
          page : this.filter.page ,
          take: this.filter.take,
          tab: this.tabCurrent
        }
      }).catch(err => {});
    },
    getFinanceList() {
      this.isBusy = true
      console.log('this.filter', this.filter);
      this.axios.post(`${this.$baseUrl}/statement`, this.filter).then((response) => {
        if (response.result === 1) {
          this.paymentStatus = response.detail.paymentStatus
          this.items = response.detail.data
          this.rows = response.detail.total
          this.isBusy = false
        }
      });
    },
    submitFilter(filter) {
      if (filter !== undefined) {
        this.filter.saleChannelId = filter.market
        if (filter.startDate !== "") {
          this.filter.startDate = this.$moment(filter.startDate).format("YYYY-MM-DD") 
        }
        if (filter.endDate !== "") {
          this.filter.endDate = this.$moment(filter.endDate).format("YYYY-MM-DD")
        }
        this.filter.keyword = filter.search
        this.filter.paymentStatusIds = filter.paymentStatusIds
      }
      this.setFilter();
      this.getFinanceList();
    },
    searchStatementNo(search) {
      this.filter.keyword = search
      this.getFinanceList();
      this.setFilter()
    },
    isActive(menuItem) {
      return this.activeItem == menuItem;
    },
    selectTab (id) {
      this.tabCurrent = id
      if (id === 0) {
        this.filter.paymentStatusIds = []
      } else {
        this.filter.paymentStatusIds = [id]
      }
      this.setFilter()
      this.getFinanceList();
    }
  },
};
</script>

<style></style>
